import { mapTokenTransitionToCSSTransition } from "@styles/utils/mapTokenTransitionToCSSTransition";

const transitions = {
  timingFunctions: {
    linear: "linear",
    in: [0.4, 0, 1, 1],
    out: [0, 0, 0.2, 1],
    "in-out": [0.4, 0, 0.2, 1],
    "in-out-quart": [0.77, 0, 0.175, 1],
  },
  durations: {
    "75": "75ms",
    "100": "100ms",
    "150": "150ms",
    "200": "200ms",
    "300": "300ms",
    "500": "500ms",
    "700": "700ms",
    "1000": "1000ms",
  },
};

export default transitions;

export const cssTransitions = {
  fast: mapTokenTransitionToCSSTransition(
    transitions.durations["100"],
    transitions.timingFunctions["in-out"]
  ),
  fastIn: mapTokenTransitionToCSSTransition(
    transitions.durations["100"],
    transitions.timingFunctions["in"]
  ),
  fastOut: mapTokenTransitionToCSSTransition(
    transitions.durations["100"],
    transitions.timingFunctions["out"]
  ),

  standard: mapTokenTransitionToCSSTransition(
    transitions.durations["300"],
    transitions.timingFunctions["in-out"]
  ),
  standardIn: mapTokenTransitionToCSSTransition(
    transitions.durations["300"],
    transitions.timingFunctions["in"]
  ),
  standardOut: mapTokenTransitionToCSSTransition(
    transitions.durations["300"],
    transitions.timingFunctions["out"]
  ),

  slow: mapTokenTransitionToCSSTransition(
    transitions.durations["500"],
    transitions.timingFunctions["in-out"]
  ),
  slowIn: mapTokenTransitionToCSSTransition(
    transitions.durations["500"],
    transitions.timingFunctions["in"]
  ),
  slowOut: mapTokenTransitionToCSSTransition(
    transitions.durations["500"],
    transitions.timingFunctions["out"]
  ),
};
